import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/contexts/ContentContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import About from "@/components/About";
import Courses from "@/components/Courses";
import Offers from "@/components/Offers";
import Faculty from "@/components/Faculty";
import Achievements from "@/components/Achievements";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import EnrollDialog from "@/components/EnrollDialog";
import SeoHead from "@/components/SeoHead";
import { useEnroll } from "@/hooks/useEnroll";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import RequireAdmin from "@/admin/RequireAdmin";

function PublicSite() {
  const { open, setOpen } = useEnroll();
  return (
    <div className="App bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <About />
        <Courses />
        <Offers />
        <Faculty />
        <Achievements />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
      <EnrollDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}

function App() {
  return (
    <ContentProvider>
      <SeoHead />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<RequireAdmin />}>
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </ContentProvider>
  );
}

export default App;
